import * as FileSaver from 'file-saver';
import moment from 'moment';
import findExcelTemplate from './templates/ExcelTemplate';
import populateExcelFile from './templates/ExcelTemplatePopulator';
import TableDefinitions from '../../TableDefinitions';

export const saveFile = (filename, file) => {
  const buf = new ArrayBuffer(file.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== file.length; i += 1) {
    view[i] = file.charCodeAt(i) & 0xFF; // eslint-disable-line no-bitwise
  }

  FileSaver.saveAs(
    new window.Blob([buf], { type: 'application/octet-stream' }),
    filename,
  );
};

const downloadTableAsXlsx = (data, columns, templateFile, downloadFileName) => {
  let excelTemplateFile;
  try {
    excelTemplateFile = findExcelTemplate(templateFile);
  } catch (e) {
    throw new Error(`unable to find the given template file (${templateFile}.xlsx) on excel-templates folder.`);
  }
  const populatedExcelFile = populateExcelFile(excelTemplateFile, data, columns);

  const fileName = `${downloadFileName}_${moment().local().format('YYYY-MM-DD HH:mm:ss')}.xlsx`;
  saveFile(fileName, populatedExcelFile);
};

export default downloadTableAsXlsx;
